import * as React from 'react';
import { StatsReportsLayout, } from '@Layouts';

const StatsReportsPage: React.FC = () => <StatsReportsLayout />;

export default StatsReportsPage;
